import React from 'react';
import { FaLock } from 'react-icons/fa';
function Collect() {
  return (
    <div className="container py-4">
      <h1 className="display-4 mb-4 text-center">Collect</h1>
      <p className="lead text-center mb-4">
        <FaLock /> Secure payments with Square.
      </p>

      <div className="d-flex justify-content-center">
        <div style={{
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          alignItems: 'center',
          width: '259px',
          background: '#FFFFFF',
          border: '1px solid rgba(0, 0, 0, 0.1)',
          boxShadow: '-2px 10px 5px rgba(0, 0, 0, 0)',
          borderRadius: '10px',
          fontFamily: 'SQ Market, SQ Market, Helvetica, Arial, sans-serif',
        }}>
          <img
            src="https://items-images-production.s3.us-west-2.amazonaws.com/files/b13eb98c9329ddbd07240208f2e25edd866fbfb8/original.jpeg"
            alt="BioEra™ Golden Grasslands Kit - First Edition"
            onError={(e) => e.target.style.display = 'none'}
            style={{ width: '100%' }}
          />
          <div style={{ padding: '20px' }}>
            <p style={{
              fontSize: '18px',
              lineHeight: '20px',
            }}>BioEra™ Golden Grasslands Kit - First Edition</p>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://square.link/u/7OAOVPce?src=embed"
              style={{
                display: 'inline-block',
                fontSize: '18px',
                lineHeight: '48px',
                height: '48px',
                color: '#ffffff',
                minWidth: '212px',
                backgroundColor: '#3eab73',
                textAlign: 'center',
                boxShadow: '0 0 0 1px rgba(0,0,0,.1) inset',
                borderRadius: '6px',
                textDecoration: 'none'
              }}
            >Buy now</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Collect;
